import {
  AloftDate,
  SimilarityScoreWeightsForLocationType,
  calculateSimilarityScoreWithBreakdown,
} from '@aloft/toolkit-shared';

import { calcSimilarity } from '../internal/similarity/calcSimilarity.ts';
import { CompSelectionProperty } from '../types.ts';
import { toSimilarityScoreCharacteristics } from './toSimilarityScoreCharacteristics.ts';

export type NewSimilarityScoreCalcOptions = {
  weights: SimilarityScoreWeightsForLocationType;
  effectiveDate: AloftDate;
};

export const addSimilarityScores = (
  properties: CompSelectionProperty[],
  subject: CompSelectionProperty,
  newCalcOptions?: NewSimilarityScoreCalcOptions,
) => {
  if (newCalcOptions) {
    const { weights, effectiveDate } = newCalcOptions;
    const subjectChars = toSimilarityScoreCharacteristics(subject, effectiveDate, true);
    const pool = properties.map((p) => toSimilarityScoreCharacteristics(p, effectiveDate));

    // Store subject characteristics so the breakdown tooltip can compute diffs.
    // eslint-disable-next-line no-param-reassign
    subject.similarityCharacteristics = subjectChars;

    properties.forEach((prop) => {
      const compChars = toSimilarityScoreCharacteristics(prop, effectiveDate);
      const { score, breakdown } = calculateSimilarityScoreWithBreakdown(
        weights,
        subjectChars,
        compChars,
        pool,
      );
      // eslint-disable-next-line no-param-reassign
      prop.similarityScore = score;
      // eslint-disable-next-line no-param-reassign
      prop.similarityBreakdown = breakdown;
      // eslint-disable-next-line no-param-reassign
      prop.similarityCharacteristics = compChars;
    });
  } else {
    properties.forEach((prop) => {
      // eslint-disable-next-line no-param-reassign
      prop.similarityScore = calcSimilarity(subject, prop);
    });
  }
};
